var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "saas_module_plate_swipe_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c("div", [_vm._v("示意样式")]),
      _c("el-image", {
        staticClass: "icon",
        attrs: {
          fit: "contain",
          src: "https://res.youlianfuwu.com/mini_program/shop/saas-zuohua.jpg",
        },
      }),
      _c("div", { staticClass: "tips" }, [
        _vm._v(" 企业添加了SaaS活动板块，要展示活动列表时可选用该组件 "),
      ]),
      _c(
        "el-form-item",
        { attrs: { prop: "type" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 头部配置方式 ")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.type,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "type", $$v)
                },
                expression: "value.config.type",
              },
            },
            [
              _c("el-radio", { attrs: { label: "1" } }, [
                _vm._v("填写名称形式"),
              ]),
              _c("el-radio", { attrs: { label: "2" } }, [
                _vm._v("上传头图形式"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "box" },
        [
          _vm.value.config.type === "1"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { prop: "name" } },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("顶部标题")]),
                    _c("el-input", {
                      attrs: { placeholder: "请输入标题名称", clearable: "" },
                      model: {
                        value: _vm.value.config.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "name", $$v)
                        },
                        expression: "value.config.name",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.value.config.type === "2"
            ? [
                _c("div", { staticClass: "title" }, [_vm._v(" 头部图片 ")]),
                _c("el-form-item", { attrs: { prop: "header_image" } }, [
                  _c(
                    "div",
                    { staticClass: "upload-item-wrap" },
                    [
                      _c("upload-file", {
                        ref: "headerImage",
                        attrs: {
                          "link-url": _vm.linkUrl,
                          tempurl: _vm.value.config.header_image,
                          canDel: Boolean(_vm.value.config.header_image),
                          deletePadding: true,
                          uploadInfo: _vm.uploadInfo,
                        },
                        on: {
                          onDelete: function ($event) {
                            return _vm.onDelete("header_image")
                          },
                          emitUploadFile: function (url) {
                            return _vm.emitUploadFile("header_image", url)
                          },
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "right" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { margin: "0" },
                              on: {
                                click: function ($event) {
                                  return _vm.onUpload("headerImage")
                                },
                              },
                            },
                            [_vm._v("上传图片")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      " 建议尺寸为690*92，支持JPG、PNG等格式，大小不超过2M "
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "image_style" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("侧滑楼层图片样式")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.image_style,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "image_style", $$v)
                },
                expression: "value.config.image_style",
              },
            },
            [
              _c("el-radio", { attrs: { label: "1" } }, [_vm._v("长图")]),
              _c("el-radio", { attrs: { label: "2" } }, [_vm._v("缩略图")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "bg_color" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("活动展示区背景色")]),
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.bg_color,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "bg_color", $$v)
              },
              expression: "value.config.bg_color",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "module_plate_id" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("展示的SaaS活动板块")]),
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: "请选择板块",
                clearable: "",
                filterable: "",
              },
              on: { change: _vm.changeModule },
              model: {
                value: _vm.value.config.module_plate_id,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "module_plate_id", $$v)
                },
                expression: "value.config.module_plate_id",
              },
            },
            _vm._l(_vm.moduleList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "activity_num" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("展示的活动个数")]),
          _c("el-input", {
            attrs: { placeholder: "请输入个数", clearable: "" },
            model: {
              value: _vm.value.config.activity_num,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "activity_num", $$v)
              },
              expression: "value.config.activity_num",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }